var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ens1",
    gradientUnits: "userSpaceOnUse",
    x1: 135.7882,
    y1: 437.9683,
    x2: 51.7068,
    y2: 346.8181,
    gradientTransform: "matrix(1 0 0 -1 -6 650.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#A0A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#8791C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#6470B4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ens1)",
    d: "M53.5,303.4c2.3,4.9,8,14.6,8,14.6l65.5-108.3L63,254.3c-3.8,2.5-6.9,6-9.1,10 C48,276.6,47.9,290.9,53.5,303.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A8D4",
    d: "M27.5,339c1.5,21,11.9,40.3,28.6,53l70.7,49.3c0,0-44.2-63.8-81.6-127.2c-3.8-6.7-6.3-14-7.5-21.6 c-0.5-3.4-0.5-6.9,0-10.4c-1,1.8-2.9,5.5-2.9,5.5c-3.8,7.7-6.4,16-7.6,24.5C26.6,321,26.6,330.1,27.5,339z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ens2",
    gradientUnits: "userSpaceOnUse",
    x1: 137.5985,
    y1: 211.5875,
    x2: 221.6924,
    y2: 302.7203,
    gradientTransform: "matrix(1 0 0 -1 -6 650.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#A0A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#8791C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#6470B4"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ens2)",
    d: "M207.9,347.6c-2.3-4.9-8-14.6-8-14.6l-65.5,108.3l63.9-44.6c3.8-2.5,6.9-6,9.1-10 C213.4,374.3,213.5,360,207.9,347.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A8D4",
    d: "M233.9,311.9c-1.5-21-11.9-40.3-28.6-53l-70.7-49.3c0,0,44.2,63.8,81.6,127.2c3.8,6.7,6.3,14,7.5,21.6 c0.5,3.4,0.5,6.9,0,10.4c1-1.8,2.9-5.5,2.9-5.5c3.8-7.7,6.4-16,7.6-24.5C234.8,329.9,234.8,320.9,233.9,311.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ens3",
    gradientUnits: "userSpaceOnUse",
    x1: 136.6882,
    y1: 441.7469,
    x2: 136.6882,
    y2: 208.2323,
    gradientTransform: "matrix(1 0 0 -1 -6 650.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#513EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#5157FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#5298FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52E5FF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ens3)",
    d: "M53.9,264.3c2.2-4,5.3-7.5,9.1-10l63.9-44.6L61.4,318c0,0-5.7-9.7-8-14.6C47.8,290.9,48,276.6,53.9,264.3z  M27.5,339c1.5,21,11.9,40.3,28.6,53l70.7,49.3c0,0-44.2-63.8-81.6-127.2c-3.8-6.7-6.3-14-7.5-21.6c-0.5-3.4-0.5-6.9,0-10.4 c-1,1.8-2.9,5.5-2.9,5.5c-3.8,7.7-6.4,16-7.6,24.5C26.6,321,26.6,330.1,27.5,339z M207.8,347.6c-2.3-4.9-8-14.6-8-14.6 l-65.4,108.3l63.9-44.6c3.8-2.5,6.9-6,9.1-10c5.9-12.3,6.1-26.6,0.4-39.1L207.8,347.6z M233.8,312c-1.5-21-11.9-40.3-28.6-53 l-70.6-49.3c0,0,44.2,63.8,81.6,127.2c3.8,6.7,6.3,14,7.5,21.6c0.5,3.4,0.5,6.9,0,10.4c1-1.8,2.9-5.5,2.9-5.5 c3.8-7.7,6.4-16,7.6-24.5c0.7-9,0.7-18-0.2-27L233.8,312z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M301.6,386.5V266.7c0-0.3,0.3-0.6,0.6-0.6h76.1c0.3,0,0.6,0.3,0.6,0.6V282c0,0.3-0.3,0.6-0.6,0.6H320v35.3h49.7 c0.3,0,0.6,0.3,0.6,0.6l0,0v15.1c0,0.3-0.3,0.6-0.6,0.6l0,0H320v36.4h58.4c0.3,0,0.6,0.3,0.6,0.6l0,0v15.3c0,0.3-0.3,0.6-0.6,0.6 l0,0h-76.1C301.9,387.1,301.6,386.9,301.6,386.5z M491,386.8L435.3,302v84.5c0,0.3-0.3,0.6-0.6,0.6c0,0,0,0,0,0h-17.2 c-0.3,0-0.6-0.3-0.6-0.6c0,0,0,0,0,0V266.8c0-0.3,0.3-0.6,0.6-0.6l0,0h15.9c0.2,0,0.4,0.1,0.5,0.3l55.8,84.7v-84.3 c0-0.3,0.3-0.6,0.6-0.6l0,0h17.2c0.3,0,0.6,0.3,0.6,0.6l0,0v119.7c0,0.3-0.3,0.6-0.6,0.6l0,0h-15.9C491.3,387.1,491.1,387,491,386.8 z M564.3,363.9v5.7c7.4,1.6,14.9,2.5,22.4,2.6c7.4-0.2,14.8-1,22.1-2.6v-27.1l-62.3-21.8c-0.2-0.1-0.4-0.3-0.4-0.6v-49.8 c0-0.3,0.1-0.5,0.4-0.6c13-3.6,26.4-5.6,39.9-5.7c13.5,0.2,27,2.1,40.1,5.7c0.3,0.1,0.4,0.3,0.4,0.6v18.8c0,0.3-0.3,0.6-0.6,0.6l0,0 h-16.9c-0.3,0-0.6-0.3-0.6-0.6l0,0v-5.7c-7.4-1.6-14.9-2.5-22.4-2.6c-7.4,0.1-14.8,1-22.1,2.6l0.1,25.6l62.1,21.7 c0.2,0.1,0.4,0.3,0.4,0.6v51.4c0,0.3-0.1,0.5-0.4,0.6c-13,3.6-26.4,5.6-39.9,5.7c-13.5-0.2-27-2.1-40.1-5.7 c-0.3-0.1-0.4-0.3-0.4-0.6v-18.8c0-0.3,0.3-0.6,0.6-0.6l0,0h16.8c0.3-0.1,0.7,0.1,0.8,0.4C564.3,363.8,564.3,363.8,564.3,363.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEns);
export default __webpack_public_path__ + "static/media/ens.8a455fb9fc77604c7ad30e1b3b338dff.svg";
export { ForwardRef as ReactComponent };